module.exports = __webpack_public_path__ + "img/advantage_4.33e17a84.svg";